module.exports = __webpack_public_path__ + "static/media/image3.69eff780.jpg";